module.exports = __webpack_public_path__ + "images/certificate-of-completion.png";